module.exports = __webpack_public_path__ + "GradeComparisonReport2-d3f9c72bc401e6fc02ac138abf726521.png";